export enum NotificationName {
    SomethingWentWrong = 'SOMETHING_WENT_WRONG',
    CheckBannerModeration = 'CHECK_BANNER_MODERATION',
    SendRefund = 'SEND_REFUND',
    InvoicesPageError = 'INVOICES_PAGE_ERROR',
    SendBonus = 'SEND_BONUS',
    InvoicesPageErrorMaxPeriod = 'INVOICES_PAGE_ERROR_MAX_PERIOD',
    CrmUpdateSuccess = 'CRM_UPDATE_SUCCESS',
    CrmUpdateError = 'CRM_UPDATE_ERROR',
    CrmUpdateAlert = 'CRM_UPDATE_ALERT',
    UsersPageErrorSomethingWentWrong = 'USERS_PAGE_ERROR_SOMETHING_WENT_WRONG',
    CampaignFormImageSuccess = 'CAMPAIGN_FORM_IMAGE_SUCCESS',
    CampaignFormImageReady = 'CAMPAIGN_FORM_IMAGE_READY',
    CampaignFormImageTooHighResolution = 'CAMPAIGN_FORM_IMAGE_TOO_HIGH_RESOLUTION',
    CampaignFormImageTooLowResolution = 'CAMPAIGN_FORM_IMAGE_TOO_LOW_RESOLUTION',
    CampaignFormImageTooLowResolutionForSources = 'CAMPAIGN_FORM_IMAGE_TOO_LOW_RESOLUTION_FOR_SOURCES',
    CampaignFormImageTooBigSize = 'CAMPAIGN_FORM_IMAGE_TOO_BIG_SIZE',
    CampaignFormImageWrongExtension = 'CAMPAIGN_FORM_IMAGE_WRONG_EXTENSION',
    CampaignFormImageSomethingWentWrong = 'CAMPAIGN_FORM_IMAGE_SOMETHING_WENT_WRONG',
    CampaignFormCropImageSomethingWentWrong = 'CAMPAIGN_FORM_CROP_IMAGE_SOMETHING_WENT_WRONG',
    CampaignFormImageCancel = 'CAMPAIGN_FORM_IMAGE_CANCEL',
    CampaignFormImageUnableToCropImage = 'CAMPAIGN_FORM_IMAGE_UNABLE_TO_CROP_IMAGE',
    CampaignFormDefaultImagesError = 'CAMPAIGN_FORM_DEFAULT_IMAGES_ERROR',
    CampaignFormFieldsError = 'CAMPAIGN_FORM_FIELDS_ERROR',
    CampaignsSearchSomethingWentWrong = 'CAMPAIGNS_SEARCH_SOMETHING_WENT_WRONG',
    DashboardFiltersSomethingWentWrong = 'DASHBOARD_FILTERS_SOMETHING_WENT_WRONG',
    DashboardCampaignListSomethingWentWrong = 'DASHBOARD_CAMPAIGN_LIST_SOMETHING_WENT_WRONG',
    DashboardLoadFiltersSomethingWentWrong = 'DASHBOARD_LOAD_FILTERS_SOMETHING_WENT_WRONG',
    ImageUpscaleSomethingWentWrong = 'IMAGE_UPSCALE_SOMETHING_WENT_WRONG',
    ImageUpscaleInfoSomethingWentWrong = 'IMAGE_UPSCALE_INFO_SOMETHING_WENT_WRONG',
    PayersPageErrorEmptyValue = 'PAYERS_PAGE_ERROR_EMPTY_VALUE',
    PayersPageUpdatePayerDataSuccess = 'PAYERS_PAGE_UPDATE_PAYER_DATA_SUCCESS',
    PayersPageUpdatePayerDataError = 'PAYERS_PAGE_UPDATE_PAYER_DATA_ERROR',
    TranslationsSaveSuccess = 'TRANSLATIONS_SAVE_SUCCESS',
    AccountStatisticsNotAccountId = 'ACCOUNT_STATISTICS_NOT_ACCOUNT_ID',
    AccountCreateSuccess = 'ACCOUNT_CREATE_SUCCESS',
    AccountEditSuccess = 'ACCOUNT_EDIT_SUCCESS',
    CampaignsReportError = 'CAMPAIGNS_REPORT_ERROR',
    UseBannerLinkForVacancy = 'USE_BANNER_LINK_FOR_VACANCY',
    ErrorAccessInBannerLink = 'ERROR_ACCESS_IN_BANNER_LINK',
    ErrorVacancyInBannerLink = 'ERROR_VACANCY_IN_BANNER_LINK',
    ErrorUrlInBannerLink = 'ERROR_URL_IN_BANNER_LINK',
    CreateCampaignSomethingWentWrongError = 'CREATE_CAMPAIGN_SOMETHING_WENT_WRONG_ERROR',
    CreateBannerSomethingWentWrongError = 'CREATE_BANNER_SOMETHING_WENT_WRONG_ERROR',
    AuctionFormValidationError = 'AUCTION_FORM_VALIDATION_ERROR',
    AuctionFormLowBalanceError = 'AUCTION_FORM_LOW_BALANCE_ERROR',
    AuctionFormSomethingWentWrongError = 'AUCTION_FORM_SOMETHING_WENT_WRONG_ERROR',
    AuctionFormDuplicatedCampaignError = 'AUCTION_FORM_DUPLICATED_CAMPAIGN_ERROR',
    CampaignCopySuccess = 'CAMPAIGN_COPY_SUCCESS',
    CampaignsReportMaxDateError = 'CAMPAIGNS_REPORT_MAX_DATE_ERROR',
    EditingActDataError = 'EDITING_ACT_DATA_ERROR',
    EditingActForbiddenError = 'EDITING_ACT_FORBIDDEN_ERROR',
    EditingActNotFoundError = 'EDITING_ACT_NOT_FOUND_ERROR',
    DuplicateActError = 'DUPLICATE_ACT_ERROR',
    CampaignChangeStatusToArchiveSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_ARCHIVE_SUCCESS',
    CampaignChangeStatusToActiveSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_ACTIVE_SUCCESS',
    CampaignMultiChangeStatusToBlockedSuccess = 'CAMPAIGN_MULTI_CHANGE_STATUS_TO_BLOCKED_SUCCESS',
    CampaignMultiChangeStatusToBlockedError = 'CAMPAIGN_MULTI_CHANGE_STATUS_TO_BLOCKED_ERROR',
    CampaignFormVideoTooBigSize = 'CAMPAIGN_FORM_VIDEO_TOO_BIG_SIZE',
    CampaignFormVideoTooLongDuration = 'CAMPAIGN_FORM_VIDEO_TOO_LONG_DURATION',
    CampaignFormVideoTooShortDuration = 'CAMPAIGN_FORM_VIDEO_TOO_SHORT_DURATION',
    CampaignFormVideoWrongResolution = 'CAMPAIGN_FORM_VIDEO_WRONG_RESOLUTION',
    CampaignFormVideoSomethingWentWrong = 'CAMPAIGN_FORM_VIDEO_SOMETHING_WENT_WRONG',
    CampaignFormVideoWrongFormat = 'CAMPAIGN_FORM_VIDEO_WRONG_FORMAT',
    CampaignFormVideoErrorWhileProcess = 'CAMPAIGN_FORM_VIDEO_ERROR_WHILE_PROCESS',
    BannerLinkCopyToClipboardSuccess = 'BANNER_LINK_COPY_TO_CLIPBOARD_SUCCESS',
    CampaignArchiveError = 'CAMPAIGN_ARCHIVE_ERROR',
}

export enum MagritteNotificationName {
    SomethingWentWrong = 'SOMETHING_WENT_WRONG',
    AiImageGenerationSomethingWentWrong = 'AI_IMAGE_GENERATION_SOMETHING_WENT_WRONG',
    BannerTextGenerationSomethingWentWrong = 'BANNER_TEXT_GENERATION_SOMETHING_WENT_WRONG',
    AuctionBuilderCreateSuccess = 'AUCTION_BUILDER_CREATE_SUCCESS',
    AuctionBuilderDuplicatedCampaignError = 'AUCTION_BUILDER_DUPLICATED_CAMPAIGN_ERROR',
    AuctionBuilderLowBalanceError = 'AUCTION_BUILDER_LOW_BALANCE_ERROR',
    AuctionBuilderSaveSuccess = 'AUCTION_BUILDER_SAVE_SUCCESS',
    AuctionBuilderSomethingWentWrongError = 'AUCTION_BUILDER_SOMETHING_WENT_WRONG_ERROR',
    AuctionBuilderValidationError = 'AUCTION_BUILDER_VALIDATION_ERROR',
    BalanceRefundError = 'BALANCE_REFUND_ERROR',
    BalanceRefundSuccess = 'BALANCE_REFUND_SUCCESS',
    CampaignArchiveError = 'CAMPAIGN_ARCHIVE_ERROR',
    CampaignChangeStatusToArchiveSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_ARCHIVE_SUCCESS',
    CampaignCopySuccess = 'CAMPAIGN_COPY_SUCCESS',
    CampaignFormDefaultImagesError = 'CAMPAIGN_FORM_DEFAULT_IMAGES_ERROR',
    CampaignMultiBudgetIncreaseError = 'CAMPAIGN_MULTI_BUDGET_INCREASE_ERROR',
    CampaignsReportError = 'CAMPAIGNS_REPORT_ERROR',
    CampaignStatisticCardSomethingWentWrong = 'CAMPAIGN_STATISTIC_CARD_SOMETHING_WENT_WRONG',
    CopiedToClipboard = 'COPIED_TO_CLIPBOARD',
    CreateQuickCampaignSaveSuccess = 'CREATE_QUICK_CAMPAIGN_SAVE_SUCCESS',
    CreateQuickCampaignValidationError = 'CREATE_QUICK_CAMPAIGN_VALIDATION_ERROR',
    CreateQuickCampaignRegionUnavailableError = 'CREATE_QUICK_CAMPAIGN_REGION_UNAVAILABLE_ERROR',
    CreateQuickCampaignAreaUnavailableError = 'CREATE_QUICK_CAMPAIGN_AREA_UNAVAILABLE_ERROR',
    CreateQuickCampaignSomethingWentWrongError = 'CREATE_QUICK_CAMPAIGN_SOMETHING_WENT_WRONG_ERROR',
    CropModalRequiredImagesError = 'CROP_MODAL_REQUIRED_IMAGES_ERROR',
    ErrorAccessInBannerLink = 'ERROR_ACCESS_IN_BANNER_LINK',
    ErrorVacancyInBannerLink = 'ERROR_VACANCY_IN_BANNER_LINK',
    ErrorUrlInBannerLink = 'ERROR_URL_IN_BANNER_LINK',
    MultiCreationAuctionIncorrectCount = 'MULTI_CREATION_AUCTION_INCORRECT_COUNT',
    MultiCreationAuctionUnknownError = 'MULTI_CREATION_AUCTION_UNKNOWN_ERROR',
    MultiCreationAuctionValidationError = 'MULTI_CREATION_AUCTION_VALIDATION_ERROR',
    BannerModerationInfoSomethingWentWrongError = 'BANNER_MODERATION_INFO_SOMETHING_WENT_WRONG_ERROR',
    RequisitesFormValidationError = 'REQUISITES_FORM_VALIDATION_ERROR',
    RequisitesSaveSuccess = 'REQUISITES_SAVE_SUCCESS',
    RequisitesSaveForbiddenError = 'REQUISITES_SAVE_FORBIDDEN_ERROR',
    SaveImageToGallerySomethingWentWrong = 'SAVE_IMAGE_TO_GALLERY_SOMETHING_WENT_WRONG',
    SaveImageToGallerySuccess = 'SAVE_IMAGE_TO_GALLERY_SUCCESS',
    CreateCampaignSomethingWentWrongError = 'CREATE_CAMPAIGN_SOMETHING_WENT_WRONG_ERROR',
    CreateBannerSomethingWentWrongError = 'CREATE_BANNER_SOMETHING_WENT_WRONG_ERROR',
    CampaignFormFieldsError = 'CAMPAIGN_FORM_FIELDS_ERROR',
    CampaignFormImageTooBigSize = 'CAMPAIGN_FORM_IMAGE_TOO_BIG_SIZE',
    CampaignFormImageWrongExtension = 'CAMPAIGN_FORM_IMAGE_WRONG_EXTENSION',
    CampaignFormImageTooHighResolution = 'CAMPAIGN_FORM_IMAGE_TOO_HIGH_RESOLUTION',
    CampaignFormImageTooLowResolution = 'CAMPAIGN_FORM_IMAGE_TOO_LOW_RESOLUTION',
    CampaignFormImageTooLowResolutionForSources = 'CAMPAIGN_FORM_IMAGE_TOO_LOW_RESOLUTION_FOR_SOURCES',
    CampaignFormImageSomethingWentWrong = 'CAMPAIGN_FORM_IMAGE_SOMETHING_WENT_WRONG',
    CampaignFormImageUnableToCropImage = 'CAMPAIGN_FORM_IMAGE_UNABLE_TO_CROP_IMAGE',
    CampaignFormVideoTooBigSize = 'CAMPAIGN_FORM_VIDEO_TOO_BIG_SIZE',
    CampaignFormVideoTooLongDuration = 'CAMPAIGN_FORM_VIDEO_TOO_LONG_DURATION',
    CampaignFormVideoTooShortDuration = 'CAMPAIGN_FORM_VIDEO_TOO_SHORT_DURATION',
    CampaignFormVideoWrongResolution = 'CAMPAIGN_FORM_VIDEO_WRONG_RESOLUTION',
    CampaignFormVideoSomethingWentWrong = 'CAMPAIGN_FORM_VIDEO_SOMETHING_WENT_WRONG',
    CampaignFormVideoWrongFormat = 'CAMPAIGN_FORM_VIDEO_WRONG_FORMAT',
    CampaignFormVideoErrorWhileProcess = 'CAMPAIGN_FORM_VIDEO_ERROR_WHILE_PROCESS',
    PromoCodeAlreadyUsed = 'PROMO_CODE_ALREADY_USED',
    PromoCodeFailed = 'PROMO_CODE_FAILED',
    PromoCodeActivationError = 'PROMO_CODE_ACTIVATION_ERROR',
    ReportDownloadError = 'REPORT_DOWNLOAD_ERROR',
    AdminStopPromoCodeError = 'ADMIN_STOP_PROMO_CODE_ERROR',
    AdminCreatePromoCodeSuccess = 'ADMIN_CREATE_PROMO_CODE_SUCCESS',
    AdminCreatePromoCodeError = 'ADMIN_CREATE_PROMO_CODE_ERROR',
    AdminUpdatePromoCodeSuccess = 'ADMIN_UPDATE_PROMO_CODE_SUCCESS',
    AdminUpdatePromoCodeError = 'ADMIN_UPDATE_PROMO_CODE_ERROR',
    AdminCreateOrUpdatePromoCodeValidationError = 'ADMIN_CREATE_OR_UPDATE_PROMO_CODE_VALIDATION_ERROR',
    AdminCreatePromoCodeDuplicationError = 'ADMIN_CREATE_PROMO_CODE_DUPLICATION_ERROR',
    ImageUpscaleSomethingWentWrong = 'IMAGE_UPSCALE_SOMETHING_WENT_WRONG',
    ImageUpscaleInfoSomethingWentWrong = 'IMAGE_UPSCALE_INFO_SOMETHING_WENT_WRONG',
    BalanceReBalanceSuccess = 'BALANCE_RE_BALANCE_SUCCESS',
    BalanceReBalanceError = 'BALANCE_RE_BALANCE_ERROR',
    SubscriptionSettingsSaveSuccess = 'SUBSCRIPTION_SETTINGS_SAVE_SUCCESS',
    SubscriptionSettingsSaveError = 'SUBSCRIPTION_SETTINGS_SAVE_ERROR',
    LinkCopyToClipboardSuccess = 'LINK_COPY_TO_CLIPBOARD_SUCCESS',
    VacancyIdCopyToClipboardSuccess = 'VACANCY_ID_COPY_TO_CLIPBOARD_SUCCESS',
    AdQuickCreateWithForeignArea = 'AD_QUICK_CREATE_WITH_FOREIGN_AREA',
    CampaignChangeStatusToActiveSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_ACTIVE_SUCCESS',
    CampaignChangeStatusToActiveAndMoveSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_ACTIVE_AND_MOVE_SUCCESS',
    CampaignChangeStatusToPausedSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_PAUSED_SUCCESS',
    CampaignChangeStatusToPausedAndMoveSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_PAUSED_AND_MOVE_SUCCESS',
    CampaignChangeStatusToArchivedSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_ARCHIVED_SUCCESS',
    CampaignChangeStatusToArchivedAndMoveSuccess = 'CAMPAIGN_CHANGE_STATUS_TO_ARCHIVED_AND_MOVE_SUCCESS',
    CampaignChangeStatusFailed = 'CAMPAIGN_CHANGE_STATUS_FAILED',
    CampaignBudgetIncreaseTotalFailed = 'CAMPAIGN_BUDGET_INCREASE_TOTAL_FAILED',
    CampaignBudgetIncreasePartialFailed = 'CAMPAIGN_BUDGET_INCREASE_PARTIAL_FAILED',
    CampaignMultiChangeStatusToBlockedError = 'CAMPAIGN_MULTI_CHANGE_STATUS_TO_BLOCKED_ERROR',
    VrCampaignRequestSuccess = 'VR_CAMPAIGN_REQUEST_SUCCESS',
    UsersPageErrorEmptyValue = 'USERS_PAGE_ERROR_EMPTY_VALUE',
    UsersPageErrorSomethingWentWrong = 'USERS_PAGE_ERROR_SOMETHING_WENT_WRONG',
    UsersPageUpdateUserData = 'USERS_PAGE_UPDATE_USER_DATA',
    UsersPageErrorUpdateUserData = 'USERS_PAGE_ERROR_UPDATE_USER_DATA',
    DownloadStatisticError = 'DOWNLOAD_STATISTIC_ERROR',
}
